const { SIGNATURE_KEY_CHANGE } = require('constants/operationTypes');
const { REGENERATE_SIGNATURE_HIGH_BIOCATCH_SCORE, REGENERATE_SIGNATURE_LOW_BIOCATCH_SCORE, SIGNATURE_KEY_CHANGE_LOW_SCORE } = require('constants/index');
//TODO Change to the real poeditor keys for the low score
const STEP_1_PROPS = {
    [REGENERATE_SIGNATURE_LOW_BIOCATCH_SCORE]: {
        stepTitle: 'signatureEdit-signatureEdit_lowBiocatchNewPasswordTitle',
        stepDescription: 'signatureEdit-signatureEdit_lowBiocatchNewPasswordSubtitle',
        stepDescriptionClassName: 'my-profile-keys-signature-step-1__description', 
        informativeTextWithLink: false,
    },
    [REGENERATE_SIGNATURE_HIGH_BIOCATCH_SCORE]: {
        stepTitle: 'signatureEdit-newPasswordTitle',
        stepDescription: 'signatureEdit-newPasswordSubtitle',
        stepDescriptionClassName: null,
        informativeTextWithLink: true, 
    }
}

const STEP_2_PROPS = {
    [REGENERATE_SIGNATURE_LOW_BIOCATCH_SCORE]: {
        signaturePatternOperationType: SIGNATURE_KEY_CHANGE_LOW_SCORE,
        stepTitle: 'signatureEdit-signatureEdit_lowBiocatchConfirmationTitle',
    },
    [REGENERATE_SIGNATURE_HIGH_BIOCATCH_SCORE]: {
        signaturePatternOperationType: SIGNATURE_KEY_CHANGE,
        stepTitle: '',
    }
}

const SUCCESS_SCREEN_PROPS = {
    [REGENERATE_SIGNATURE_LOW_BIOCATCH_SCORE]: {
        title: 'signatureEdit-signatureEdit_lowBiocatchSuccessTitle',
        subtitle: 'signatureEdit-signatureEdit_lowBiocatchSuccessSubTitle'
    },
    [REGENERATE_SIGNATURE_HIGH_BIOCATCH_SCORE]: {
        title: 'signatureEdit-successTitle',
        subtitle: 'signatureEdit-successSubTitle'
    }
}

const FAILURE_SCREEN_PROPS = {
    [REGENERATE_SIGNATURE_LOW_BIOCATCH_SCORE]: {
        cancelButton: null
    },
    [REGENERATE_SIGNATURE_HIGH_BIOCATCH_SCORE]: {
        cancelButton: {
            url: '/myprofile/keys',
            label: 'signatureEdit-signatureEdit_cancelButton'
        }
    }
}

module.exports = {
    FAILURE_SCREEN_PROPS,
    STEP_1_PROPS,
    STEP_2_PROPS,
    SUCCESS_SCREEN_PROPS,
}
